var _style, _style2, _linearGradient, _linearGradient2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "master-artboard",
    viewBox: "0 0 975.1100463867188 301.7594299316406",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 336 235.2"
    },
    width: "975.1100463867188px",
    height: "301.7594299316406px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "ee-background",
    x: 0,
    y: 0,
    width: 975.1100463867188,
    height: 301.7594299316406,
    style: {
      fill: "white",
      fillOpacity: 1,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("defs", null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "ee-google-fonts"
  }, "@import url(https://fonts.googleapis.com/css?family=Audiowide:400);")), _style2 || (_style2 = /*#__PURE__*/React.createElement("style", {
    id: "style-1"
  }, "@import url(https://fonts.googleapis.com/css?family=Anton:400|Roboto+Slab:100,300,400,700);")), /*#__PURE__*/React.createElement("path", {
    id: "text-path-0",
    d: "M 778.8464965820312 213.4612274169922 A 100 18 0 0 1 988.3533935546875 213.4612274169922 A 100 18 0 0 1 778.8464965820312 213.4612274169922 Z",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "text-path-1",
    d: "M 664.5464477539062 37.96122741699219 A 100 19 0 0 1 876.5812377929688 37.96122741699219 A 100 19 0 0 1 664.5464477539062 37.96122741699219",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "text-path-2",
    d: "M 765.3650512695312 211.70851135253906 A 100 17 0 0 1 991.5017700195312 211.70851135253906 A 100 17 0 0 1 765.3650512695312 211.70851135253906",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M 765.3650512695312 211.70851135253906 A 100 17 0 0 1 991.5017700195312 211.70851135253906 A 100 17 0 0 1 765.3650512695312 211.70851135253906",
    style: {
      fill: "none",
      stroke: "red",
      strokeWidth: 2
    }
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    "data-v-fde0c5aa": "",
    gradientTransform: "rotate(25)",
    id: "cb7da18f-e5ab-436b-b822-ff7de5925ed8",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    "data-v-fde0c5aa": "",
    offset: "0%",
    stopColor: "#8C48D2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    "data-v-fde0c5aa": "",
    offset: "100%",
    stopColor: "#CF705A",
    stopOpacity: 1
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    "data-v-fde0c5aa": "",
    gradientTransform: "rotate(25)",
    id: "gradient-1",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    "data-v-fde0c5aa": "",
    offset: "0%",
    stopColor: "#8C48D2",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    "data-v-fde0c5aa": "",
    offset: "100%",
    stopColor: "#CF705A",
    stopOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.1868290901184082, 0, 0, 1.1868290901184082, 54.10089302062988, 3.57537841796875)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect-2",
    x: 0,
    y: 0,
    width: 1179.61376953125,
    height: 248.23175048828125,
    style: {
      fill: "white",
      fillOpacity: 1,
      pointerEvents: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0155303478240967, 0, 0, 1.0155303478240967, -325.23028564453125, -64.72992420196533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 H 1380.697021 V 364.971008 H 0 V 0 Z",
    id: "rect-1",
    style: {
      fill: "white",
      fillOpacity: 0,
      pointerEvents: "none"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.2666664123535156, 0, 0, 3.2666664123535156, 192.90512084960938, -303.4721441268921)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 H 300 V 300 H 0 V 0 Z",
    "data-v-fde0c5aa": "",
    fill: "transparent",
    className: "logo-background-square"
  }), /*#__PURE__*/React.createElement("g", {
    "data-v-fde0c5aa": "",
    id: "82d259f0-a37b-43e9-9c84-059fea8baec0",
    fill: "#000000",
    transform: "matrix(2.9908973705643884,0,0,2.9908973705643884,95.2015601587349,134.50715213389802)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.80 3.51C7.80 2.03 7.03 0.57 5.01 0.57L1.43 0.57L1.43 10.22L2.35 10.22L2.35 6.44L3.96 6.44L6.61 10.22L7.73 10.22L5.05 6.44C7.04 6.40 7.80 4.98 7.80 3.51ZM2.35 1.44L5.03 1.44C6.26 1.44 6.87 2.37 6.87 3.51C6.87 4.66 6.30 5.59 4.79 5.59L2.35 5.59ZM12.45 10.36C14.31 10.36 15.88 9.00 15.88 6.93C15.88 4.86 14.31 3.54 12.45 3.54C10.58 3.54 9.03 4.86 9.03 6.93C9.03 9.00 10.58 10.36 12.45 10.36ZM12.45 9.51C11.06 9.51 9.93 8.48 9.93 6.93C9.93 5.39 11.06 4.40 12.45 4.40C13.82 4.40 14.98 5.39 14.98 6.93C14.98 8.48 13.82 9.51 12.45 9.51ZM20.66 10.35C21.60 10.35 22.43 10.01 23.02 9.45L22.46 8.85C22.01 9.25 21.39 9.49 20.69 9.49C19.26 9.49 18.10 8.47 18.10 6.94C18.10 5.40 19.26 4.40 20.69 4.40C21.39 4.40 22.01 4.65 22.46 5.05L23.02 4.44C22.43 3.89 21.60 3.54 20.66 3.54C18.80 3.54 17.21 4.87 17.21 6.94C17.21 9.02 18.80 10.35 20.66 10.35ZM30.09 10.22L26.46 6.52L29.26 3.68L28.01 3.68L25.56 6.19L25.56 0L24.67 0L24.67 10.22L25.56 10.22L25.56 6.86L28.87 10.22ZM36.82 6.93C36.82 4.86 35.46 3.54 33.60 3.54C31.75 3.54 30.27 4.86 30.27 6.93C30.27 9.00 31.75 10.36 33.60 10.36C34.83 10.36 35.95 9.77 36.53 8.72L35.76 8.39C35.32 9.10 34.52 9.51 33.63 9.51C32.31 9.51 31.33 8.72 31.18 7.32L36.81 7.32C36.82 7.20 36.82 7.06 36.82 6.93ZM31.19 6.55C31.36 5.15 32.31 4.40 33.60 4.40C34.87 4.40 35.81 5.19 35.94 6.55ZM41.30 3.68L39.80 3.68L39.80 1.08L38.92 1.08L38.92 3.68L37.73 3.68L37.73 4.45L38.92 4.45L38.92 10.22L39.80 10.22L39.80 4.45L41.30 4.45ZM42.81 10.36C43.22 10.36 43.54 10.08 43.54 9.70C43.54 9.31 43.22 9.03 42.81 9.03C42.43 9.03 42.11 9.31 42.11 9.70C42.11 10.08 42.43 10.36 42.81 10.36ZM46.02 1.90C46.41 1.90 46.72 1.64 46.72 1.27C46.72 0.90 46.41 0.63 46.02 0.63C45.65 0.63 45.33 0.90 45.33 1.27C45.33 1.64 45.65 1.90 46.02 1.90ZM45.57 10.22L46.47 10.22L46.47 3.68L45.57 3.68ZM51.67 10.36C53.54 10.36 55.10 9.00 55.10 6.93C55.10 4.86 53.54 3.54 51.67 3.54C49.81 3.54 48.26 4.86 48.26 6.93C48.26 9.00 49.81 10.36 51.67 10.36ZM51.67 9.51C50.29 9.51 49.15 8.48 49.15 6.93C49.15 5.39 50.29 4.40 51.67 4.40C53.05 4.40 54.21 5.39 54.21 6.93C54.21 8.48 53.05 9.51 51.67 9.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    "data-v-fde0c5aa": "",
    id: "04794072-8c51-4139-a510-2fec180d766b",
    stroke: "none",
    fill: "url(#cb7da18f-e5ab-436b-b822-ff7de5925ed8)",
    transform: "matrix(1.4524544874470597,0,0,1.4524544874470597,40,126.76072820084704)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.965 16.258l.707-.707 10.39 10.39-.707.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.935 26.357L26.018 5.274l.707.707L5.642 27.065z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 1v4.194h-4.194V1H31m1-1h-6.194v6.194H32V0zM31 26.806V31h-4.194v-4.194H31m1-1h-6.194V32H32v-6.194zM5.194 26.806V31H1v-4.194h4.194m1-1H0V32h6.194v-6.194z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logoMobile.1b06bd40a23a85255ef130704cef0f33.svg";
export { ForwardRef as ReactComponent };